import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {useBrand} from "../../component/BrandProvider";
import {useParams} from "react-router";

interface CurrentArmData {
	SiteCode: number;
	SiteName: string;
	PlanName: string;
	Count: number;
}

interface DiscontinuedArmData {
	SiteCode: number;
	SiteName: string;
	PlanName: string;
	PlanStatus: string;
	Count: number;
}

export const useGetArmWashesMTD = (enableInterval = true) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/ARM/Washes-MTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["MTD-Arm-Washes", url],
		queryFn: queryFn,
		refetchInterval: enableInterval === true ? 60000 * 5 : false,

		staleTime: enableInterval === true ? undefined : 60 * 60 * 1000,
		gcTime: enableInterval === true ? undefined : 59 * 60 * 1000,
		refetchOnWindowFocus: enableInterval === true ? undefined : false,
	});
};

export const useGetArmStatusMTD = () => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/ARM/Status-MTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["MTD-Arm-Status", url],
		queryFn: queryFn,
		refetchInterval: 60000 * 5,
	});
};

export const useGetArmWashesPTD = (enableInterval = true) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/ARM/Washes-PTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["PTD-Arm-Washes", url],
		queryFn: queryFn,
		refetchInterval: enableInterval === true ? 60000 * 5 : false,

		staleTime: enableInterval === true ? undefined : 60 * 60 * 1000,
		gcTime: enableInterval === true ? undefined : 59 * 60 * 1000,
		refetchOnWindowFocus: enableInterval === true ? undefined : false,
	});
};

export const useGetArmWashesFYTD = (enableInterval = true) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/ARM/Washes-FYTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["FYTD-Arm-Washes", url],
		queryFn: queryFn,
		refetchInterval: enableInterval === true ? 60000 * 5 : false,

		staleTime: enableInterval === true ? undefined : 60 * 60 * 1000,
		gcTime: enableInterval === true ? undefined : 59 * 60 * 1000,
		refetchOnWindowFocus: enableInterval === true ? undefined : false,
	});
};

export const useGetArmWashesWTD = (enableInterval = true) => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/ARM/Washes-WTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["WTD-Arm-Washes", url],
		queryFn: queryFn,
		refetchInterval: enableInterval === true ? 60000 * 5 : false,

		staleTime: enableInterval === true ? undefined : 60 * 60 * 1000,
		gcTime: enableInterval === true ? undefined : 59 * 60 * 1000,
		refetchOnWindowFocus: enableInterval === true ? undefined : false,
	});
};

export const useGetArmStatusFYTD = () => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/ARM/Status-FYTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["FYTD-Arm-Status", url],
		queryFn: queryFn,
		refetchInterval: 60000 * 5,
	});
};

export const useGetArmStatusWTD = () => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/ARM/Status-WTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["WTD-Arm-Status", url],
		queryFn: queryFn,
		refetchInterval: 60000 * 5,
	});
};

export const useGetArmStatusPTD = () => {
	const {brand} = useParams();
	const {url} = useBrand();

	const urlParam =
		brand === undefined
			? undefined
			: brand === "cleanfreak"
			? process.env.REACT_APP_API_URL_CLEANFREAK
			: process.env.REACT_APP_API_URL_RAINSTORM;

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${urlParam || url}/api/ARM/Status-PTD`);
		return response.data;
	};

	return useQuery<any[]>({
		queryKey: ["PTD-Arm-Status", url],
		queryFn: queryFn,
		refetchInterval: 60000 * 5,
	});
};

export const useGetYTDArmLoss = (body: any) => {
	const {url} = useBrand();

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${url}/api/ARM/YTD-ARM-Loss?${body["plans"] === undefined ? "" : `&plans=${body["plans"].join(",")}`}${body["sites"] === undefined ? "" : `&sites=${body["sites"].join(",")}`}`);
		const data: any = response.data;
		const returnData: any = {};

		for (const [key, value] of Object.entries(data)) {
			returnData[key] = value;
		}

		return returnData;
	};

	return useQuery<any[]>({
		queryKey: ["YTD-Arm-Loss", url, body["plans"], body["sites"]],
		queryFn: queryFn,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
};

export const useGetArmDiscontinues = (body: any) => {
	const {url} = useBrand();

	const queryFn = async (): Promise<DiscontinuedArmData[]> => {
		const response = await axios.get(
			`${url}/api/ARM/Discontinued-ARM-Count?start_date=${body["start_date"]}&end_date=${body["end_date"]}${body["plans"] === undefined ? "" : `&plans=${body["plans"].join(",")}`}${body["sites"] === undefined ? "" : `&sites=${body["sites"].join(",")}`}`
		);
		const data: any = response.data;

		return data.map((item: any) => ({
			SiteCode: item.Site_Code,
			PlanName: item.Plan_Name,
			PlanStatus: item.Plan_Status,
			SiteName: item.Site_Name,
			Count: item.Count,
		}));
	};

	return useQuery<DiscontinuedArmData[]>({
		queryKey: [
			"Discontinued-Arm-Count",
			url,
			body["start_date"],
			body["end_date"],
			body["plans"],
			body["sites"]
		],
		queryFn: queryFn,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
};

export const useGetYTDArmCount = (body: any) => {
	const {url} = useBrand();

	const queryFn = async (): Promise<any[]> => {
		const response = await axios.get(`${url}/api/ARM/YTD-ARM-Count?${body["plans"] === undefined ? "" : `&plans=${body["plans"].join(",")}`}${body["sites"] === undefined ? "" : `&sites=${body["sites"].join(",")}`}`);
		const data: any = response.data;
		const returnData: any = {};

		for (const [key, value] of Object.entries(data)) {
			returnData[key] = value;
		}

		return returnData;
	};

	return useQuery<any[]>({
		queryKey: ["YTD-Arm-Count", url, body["plans"], body["sites"]],
		queryFn: queryFn,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
};

export const useGetArmCount = (body: any) => {
	const {url} = useBrand();

	const queryFn = async (): Promise<CurrentArmData[]> => {
		const response = await axios.get(
			`${url}/api/ARM/Current-ARM-Count?start_date=${body["start_date"]}&end_date=${body["end_date"]}${body["plans"] === undefined ? "" : `&plans=${body["plans"].join(",")}`}${body["sites"] === undefined ? "" : `&sites=${body["sites"].join(",")}`}`
		);
		const data: any = response.data;

		return data.map((item: any) => ({
			SiteCode: item.Site_Code,
			PlanName: item.Plan_Name,
			SiteName: item.Site_Name,
			Count: item.Count,
		}));
	};

	return useQuery<CurrentArmData[]>({
		queryKey: [
			"Current-Arm-Count",
			url,
			body["start_date"],
			body["end_date"],
			2,
			body["plans"],
			body["sites"]
		],
		queryFn: queryFn,
		staleTime: 60 * 60 * 1000,
		gcTime: 59 * 60 * 1000,
		refetchOnWindowFocus: false,
	});
};
